import React from 'react';
import { connect } from 'react-redux';

import {
  myTeamsGet,
  unclaimedBidsGetAll,
} from '../util/thunks';

import OnboardingUI from './ui/OnboardingUI';

class Onboarding extends React.Component {

  state = {

    // Simulate a small loading period to avoid an onboarding
    // flash when initial page is loading myTeams and metamask:
    loading: true,
  };

  componentDidMount() {
    setTimeout(() => {

      //TODO: implement a feedbag endpoint
      // `/show-onboarding/:address` (true|false)
      this.props.myTeamsGet();
      this.props.unclaimedBidsGetAll();
    }, 1000);

    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000);
  }

  isNetworkLoaded() {
    return (
      this.props.web3.provider && 
      this.props.web3.feedbagUrl && 
      this.props.web3.ipfsUrl && 
      this.props.web3.ethNetwork
    );
  }

  render() {

    if (
      this.state.loading ||
      (!this.isNetworkLoaded() && this.props.web3.provider) ||
      (this.props.hasTokens || this.props.hasBids)
    ) {
      return (<span></span>);
    }

    return (
      <OnboardingUI />
    );
  }

}

const mapStateToProps = (state) => {
  return {
    hasTokens: !!state.myTeams.tokens.length,
    hasBids: !!Object.keys(state.unclaimedBids.all).length,
    web3: state.web3,
  };
};

const mapDispatchToProps = (dispatch) => ({

  myTeamsGet: () => {
    return dispatch(myTeamsGet());
  },

  unclaimedBidsGetAll: () => {
    return dispatch(unclaimedBidsGetAll());
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);



// WEBPACK FOOTER //
// ./src/components/Onboarding.js